import { useListingReviewsSectionContext } from "./ListingReviewsSectionProvider";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { AppTextButton, AppTextButtonProps } from "../../../global/ui/buttons";
import { MAX_REVIEWS } from "../../../../lib/constants";

type ListingReviewsLoadMoreProps = AppTextButtonProps;

export const ListingReviewsLoadMore = ({
  className,
  ...props
}: ListingReviewsLoadMoreProps) => {
  const { state, dispatch } = useListingReviewsSectionContext();
  const setShowAllReviews = () => {
    dispatch({ showAllReviews: !state.showAllReviews });
  };
  const reviewsRedux = useSelector(
    (state: RootState) => state.trainingPlan.reviews,
  );
  const quantityOfReviews = reviewsRedux?.length;

  if (quantityOfReviews > MAX_REVIEWS) {
    return (
      <AppTextButton
        onClick={setShowAllReviews}
        {...props}
        className={className}
      >
        {state.showAllReviews
          ? `See less reviews`
          : `See all ${quantityOfReviews} reviews`}
      </AppTextButton>
    );
  }
};
